<template>
    <div class="footer" :style="{fontSize: isPhone ? '12px': ''}">
        <div class="jump-box">
            <div v-for="item in list" class="li" :class="{phoneLI: isPhone}">
                <img src="https://cosimg.cdbost.cn/cdboost/item.png" alt="" class="item">
                <a @click="goInfo(item.url)" class="word-break">{{item.text}}</a>
                <span>[{{item.time}}]</span>
            </div>
        </div>
        <div class="contact-box" v-if="false"  :class="{contactBoxPhone: isPhone}">
            <ul class="contact">
                <img src="https://cosimg.cdbost.cn/cdboost/sy/lxdh.png" alt="" class="contact-img">
                <div class="contactCon">
                    <li class="p">请输入你的用户姓名</li>
                    <li>
                        <input v-model="userName" class="ipt" maxlength="20"/>
                    </li>
                    <li class="p" style="padding-top: 0.5em">请录入你的联系方式</li>
                    <li>
                        <input v-model="phone" type="text" maxlength="11" class="ipt"  />
                    </li>
                    <li>
                        <button @click="submit"><span style="font-size: 1.5em">提交</span></button>
                    </li>
                </div>
            </ul>
            <div class="rightCon">
                <div class="rightCon-box">
                    <p style="text-indent: 1em">已录入用户</p>
                    <ul>
                        <li v-for="item in lxList">{{item}}</li>
                        <li class="zz"></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="nav" :class="{phoneNav: isPhone}">
            <template v-if="isPhone">
                <div class="nav-list">
                    <div v-for="item in navList">
                        <div class="title">
                            <span style="font-size: 1.5em" @click="jump(item.link, item.index)">{{item.title}}</span>
                        </div>
                        <ul>
                            <li v-for="it in item.list" @click="jump(item.link, item.index, it.link)">
                                <a>{{it.text}}</a>
                            </li>
                        </ul>
                    </div>
                </div>
<!--                <div class="contact-box">-->
<!--                    <ul class="contact">-->
<!--                        <li class="p">请输入你要咨询的问题或留言建议，后台将在稍后一个工作日内联系你</li>-->
<!--                        <li>-->
<!--                            <textarea v-model="remake" class="ipt" placeholder="请输入..." />-->
<!--                        </li>-->
<!--                        <li>-->
<!--                            <input v-model="phone" type="text" maxlength="11" class="ipt" placeholder="请留下你的联系方式" />-->
<!--                            <button @click="submit"><span style="font-size: 1.5em">提交</span></button>-->
<!--                        </li>-->
<!--                    </ul>-->
<!--                </div>-->
                <div class="guanz phonebase">
                    <img src="https://cosimg.cdbost.cn/cdboost/sy/lanlogo.png" class="lanlogo" alt="">
                    <div class="img-box">
                        <div>
                            <img src="https://cosimg.cdbost.cn/cdboost/sy/AIDGJGZH.jpg" alt="">
                            <p>关注公众号</p>
                        </div>
                        <div>
                            <img src="https://cosimg.cdbost.cn/cdboost/sy/AIDGJ.png" alt="">
                            <p>AI电管家</p>
                        </div>
                    </div>
                </div>
                <div class="wx">
                    <div class="phone">
                        <img src="https://cosimg.cdbost.cn/cdboost/sy/phone.png" alt="">
                        <span style="font-size: 3em">4001363622</span>
                    </div>
                    <img src="https://cosimg.cdbost.cn/cdboost/sy/wx.png" alt="">
                    <p>扫一扫了解更多</p>
                </div>
            </template>
            <template v-else>
                <div class="nav-list">
                    <div v-for="item in navList" class="nav-list-li">
                        <div class="title">
                            <span style="font-size: 1.2em" @click="jump(item.link,item.index)">{{item.title}}</span>
                        </div>
                        <ul>
                            <li v-for="it in item.list">
                                <a @click="jump(item.link, item.index, it.link)">{{it.text}}</a>
                            </li>
                        </ul>
                    </div>
                </div>
	            <div class="guanz">
		            <div class="img-box">
			            <div>
				            <img src="https://cosimg.cdbost.cn/cdboost/sy/AIDGJGZH.jpg" alt="">
				            <p>关注公众号</p>
			            </div>
			            <div>
				            <img src="https://cosimg.cdbost.cn/cdboost/sy/AIDGJ.png" alt="">
				            <p>AI电管家</p>
			            </div>
			            <div>
				            <img src="https://cosimg.cdbost.cn/cdboost/sy/wx.png" alt="">
				            <p>扫一扫了解更多</p>
			            </div>
		            </div>
		            <div style="margin-top: 1em">联系电话：4001363622</div>
	            </div>
<!--                <div class="wx">-->
<!--                    <div class="phone">-->
<!--                        <img src="https://cosimg.cdbost.cn/cdboost/sy/phone.png" alt="">-->
<!--                        <span style="font-size: 3em">4001363622</span>-->
<!--                    </div>-->
<!--                    <img src="https://cosimg.cdbost.cn/cdboost/sy/wx.png" alt="">-->
<!--                    <p>扫一扫了解更多</p>-->
<!--                </div>-->
            </template>
        </div>
        <footer>
            <div>©2019-{{year}} 成都博高电管家科技有限公司</div>
            <a style="margin-left: 3em" target="_blank" href="https://beian.miit.gov.cn/">蜀ICP备2023034572号-3</a>
        </footer>
    </div>
</template>

<script>
    import {getPCorPhone} from "../tools";
    export default {
        name: "footer",
        data(){
            return {
                list: jumList,
                year: '',
                isPhone: false,
                phone: '',
                userName: '',
                navList: [
                    {
                        title: '解决方案',
                        link: 'solution',
                        index: 1,
                        list: [
                            {text: "整体方案介绍", link: 'ID11'},
                            {text: "智能有序充电方案", link: 'ID12'},
                            {text: "高度集成充电方案", link: 'ID13'},
                            {text: "智慧车场无人值守方案", link: 'ID14'},
                            {text: "强大充电运营平台", link: 'ID15'},
                            {text: "方案优势", link: 'ID16'},
                        ]
                    },
                    {
                        title: '产品服务',
                        link: 'service',
                        index: 2,
                        list: [
                            {text: "交流充电桩", link: 'ID21'},
                            {text: "电瓶车分布式充电桩", link: 'ID22'},
                            {text: "集中式充电桩", link: 'ID23'},
                            {text: "方案配套设施", link: 'ID24'},
                            {text: "服务保障", link: 'ID25'},
                        ]
                    },
                    {
                        title: '合作共赢',
                        link: 'cooperativeAlliance',
                        index: 3,
                        list: [
                            {text: "项目优势", link: 'ID31'},
                            {text: "市场前景", link: 'ID32'},
                            {text: "合作模式", link: 'ID33'},
                        ]
                    },
                    {
                        title: '关于我们',
                        link: 'about',
                        index: 4,
                        list: [
                            {text: "公司介绍", link: 'ID41'},
                            {text: "公司文化", link: 'ID42'},
                            {text: "公司荣誉", link: 'ID43'},
                            {text: "开疆拓土", link: 'ID44'},
                        ]
                    }
                ],
                lxList: [
                    '手机号【152****5963】， 赵** 已录入',
                    '手机号【183****0529】，张*已录入',
                    '手机号【139****4859】，李**已录入',
                    '手机号【150****2693】，于**已录入',
                    '手机号 【152****7488，张*已录入',
                ]
            }
        },
        methods: {
            goInfo(url){
                this.$router.push({path: 'introduce', query: {url: url}});
            },
            jump(link, index, id){
                if(this.$route.name === link){
                    document.getElementById(id).scrollIntoView(true);
                }else{
                    this.$emit('jump', link, index, id);
                }
            },
            getNowTime () {
                let now = new Date();
                let year = now.getFullYear(); //获取完整的年份(4位,1970-????)
                let month = now.getMonth() + 1; //获取当前月份(0-11,0代表1月)
                let today = now.getDate(); //获取当前日(1-31)
                let hour = now.getHours(); //获取当前小时数(0-23)
                let minute = now.getMinutes(); //获取当前分钟数(0-59)
                let second = now.getSeconds(); //获取当前秒数(0-59)
                let nowTime = ''
                nowTime = year + '-' + this.fillZero(month) + '-' + this.fillZero(today) + ' ' + this.fillZero(hour) + ':' +
                    this.fillZero(minute) + ':' + this.fillZero(second)
                return nowTime
            },
            fillZero (str) {
                var realNum;
                if (str < 10) {
                    realNum = '0' + str;
                } else {
                    realNum = str;
                }
                return realNum;
            },
            submit(){
                let that = this;
                console.log(this.getNowTime());
                if(!this.phone){
                    alert('你的联系方式不能为空！')
                }
                if(!this.userName){
                    alert('你的姓名不能为空！')
                }
                let xhh = new XMLHttpRequest();
                let page_url = '/heroAdd'
                let obj = "";
                obj = JSON.stringify({phone: this.phone, userName: this.userName, date: this.getNowTime()});
                xhh.open("POST", page_url, true);
                xhh.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
                xhh.onreadystatechange = function (data) {
                    console.log(xhh.readyState)
                    console.log(xhh.status)
                    if (xhh.readyState === 4) {
                        console.log(xhh.response);
                        that.phone = '';
                        that.userName = '';
                        alert('提交成功')
                    }
                };
                xhh.send(obj);
            }
        },
        created() {
            this.isPhone = getPCorPhone();
            this.year = new Date().getFullYear()
        }
    }
</script>

<style scoped  lang="scss">
.footer{
    .jump-box{
        background: #1F5A9E;
        width: 100%;
        line-height: 1.5em;
        display: flex;
        flex-wrap: wrap;
        .item{
            height: 1.5em;
            vertical-align: middle;
        }
        a{
            color: white;
            padding: 0 2em 0 0.5em;
        }
        .li{
            margin: 1em 0;
            padding: 0;
            width: calc(49% - 4em);
            display: flex;
            justify-content: flex-start;
            padding-left: 4em;
            .word-break {
                white-space: nowrap !important;
                text-overflow: ellipsis;
                word-break: keep-all;
                overflow: hidden;
                width: calc(100% - 18em);
                cursor: pointer;
            }
            &:last-child{
                border-left: 1px solid white;
            }
        }
        .phoneLI{
            padding: 1em 0;
            width: calc(100% - 2em);
            margin: 0 0 0 1em;
            .word-break {
                white-space: nowrap !important;
                text-overflow: ellipsis;
                word-break: keep-all;
                overflow: hidden;
                width: calc(100% - 15em);
            }
            &:last-child{
                border-left: none;
                border-top: 1px solid rgba(220,221,231,0.3);
            }
        }
    }
    .nav{
        background: #363B41;
        display: flex;
        justify-content: center;
        text-align: center;
        flex-wrap: wrap;
        align-items: center;
	    padding: 2em 10% 1em 10%;
	    width: 80%;
        .guanz{
	        color: #C4C7CE;
            .lanlogo{
                width: 20em;
                margin-bottom: 1em;
            }
            width: 40%;
            .img-box{
                display: flex;
                justify-content: space-between;
            }
        }
        .nav-list{
            width: 60%;
            display: flex;
            justify-content: space-around;
            .nav-list-li{
                position: relative;
	            flex: 1;
            }
            .title{
                text-align: left;
                font-weight: 500;
                position: relative;
                margin-bottom: 1em;
                cursor: pointer;
            }
            li{
                line-height: 2em;
	            text-align: left;
                a{
	                cursor: pointer;
                    text-decoration: none;
	                color: #C4C7CE;
	                &:hover{
		                color: white;
	                }
                }
            }
        }
        .wx{
            width: 20%;
            .phone{
                margin-bottom: 2em;
                img{
                    width: 2em;
                    margin-right: 0.5em;
                }
            }
        }
        p{
            font-size: 1.2em;
            margin-top: 0.5em;
        }
        img{
            width: 9em;
        }
    }
    .phoneNav{
        .phonebase{
            position: relative;
            margin-bottom: 1em;
            &:after{
                content: '';
                height: 1px;
                width: 80%;
                position: absolute;
                left: 10%;
                bottom: -1em;
                background: rgba(255,255,255,0.2);
            }
        }
        .guanz, .wx{
            width: 100%;
        }
        .guanz{
            margin-top: 1em;
        }
        .contact-box{
            width: 100%;
            .contact li{
                width: 90%;
            }
        }
        .nav-list{
            width: 100%;
            flex-wrap: wrap;
            &>div{
                width: 50%;
            }
        }
    }
    .contact-box{
        display: flex;
        background: #0F478A;
        font-size: 1.2em;
        align-items: center;
        .contact{
            width: 60%;
            display: flex;
            align-items: center;
            padding-top: 1em;
            .contact-img{
                width: 30%;
                margin: 0 2em;
            }
            .contactCon{
                width: 70%;
                li{
                    margin: 0 auto;
                    display: flex;
                    width: 80%;
                    margin-bottom: 0.5em;
                    align-items: center;
                }
                .ipt{
                    width: 100%;
                    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.8);
                    outline: none;
                    border: none;
                    border-radius: 0.5em;
                    text-indent: 1em;
                    font-size: 1em;
                }
                input{
                    width: 100% !important;
                    margin-right: 1em;
                    height: 2.5em;
                }
            }
        }
        button{
            background: #F6AE48;
            color: white;
            border: none;
            height: 3em;
            line-height: 3em;
            border-radius: 5px;
            cursor: pointer;
            width: 20em;
            margin-top: 1em;
        }
        .rightCon{
            width: 40%;
            padding: 1em 0;
            p{
                padding-bottom: 0.5em;
            }
            .rightCon-box{
                padding: 0 1em;
                border-left: 1px solid #FFFFFF;
                ul{
                    position: relative;
                    background: #073A78;
                    padding: 1em 0;
                    border-radius: 1em;
                    li{
                        text-indent: 1em;
                        line-height: 2em;
                    }
                    .zz{
                        background: -webkit-linear-gradient(top, rgba(9,57,124,1),rgba(9,57,124,0), rgba(9,57,124,1));
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        border-radius: 0.5em;
                    }
                }
            }
        }
    }
    .contactBoxPhone{
        flex-wrap: wrap;
        .contact{
            .contact-img{
                margin: 0 0 0 1em !important;
            }
            width: 100%;
            input{
                margin-right: 0 !important;
            }
        }
        .rightCon{
            width: 100%;
        }
    }
    footer{
        background: #363B41;
        height: 2.5em;
        text-align: center;
        line-height: 2.5em;
        display: flex;
        font-size: 1em;
        justify-content: center;
	    padding: 0 10%;
	    width: 80%;
	    color: #C4C7CE;
	    position: relative;
        a{
	        color: #C4C7CE;
            text-decoration: none;
        }
	    &:after{
		    content: '';
		    position: absolute;
		    left: 10%;
		    width: 80%;
		    height: 1px;
		    background: #535458;
		    top: 0;
	    }
    }
}
</style>